import { actionTypes as AUTH_ACTIONS, logout } from '../redux/actions/auth'

const checkAuthorizationError = (e, dispatch) => {
    if (e.response) {
        if (e.response.status === 401) {
            dispatch(logout())
            window.location.replace('/')
            dispatch({
                type: AUTH_ACTIONS.LOGOUT
            })
        }
    }
}

export default checkAuthorizationError